/**
 * 엑셀 업로드가 처리자 값 때문에 거부됐을 때의 응답 (IPT-613).
 *
 * 서버는 저장 전에 전수 검사하고, 하나라도 목록 밖이면 파일 전체를 거부한다
 * (`backend/src/exception-actor/actor-upload-validation.ts`).
 * 화면은 몇 행의 어떤 값이 걸렸는지 그대로 보여줘야 담당자가 고쳐서 다시 올릴 수 있다.
 */
export interface ActorRejection {
  message: string;
  invalidActors: { row: number; value: string }[];
  allowedActors: string[];
}

/** axios 오류에서 처리자 거부 응답만 골라낸다. 다른 오류면 null */
export const toActorRejection = (error: unknown): ActorRejection | null => {
  const data = (error as { response?: { data?: unknown } })?.response?.data as
    | Partial<ActorRejection>
    | undefined;

  if (!data || !Array.isArray(data.invalidActors) || data.invalidActors.length === 0) return null;

  return {
    message: data.message ?? '처리자 값 오류로 업로드를 중단했습니다.',
    invalidActors: data.invalidActors,
    allowedActors: data.allowedActors ?? [],
  };
};
